import {Component, Input, OnInit} from '@angular/core';
import {TransportInterventionsPageRequest} from '../transport-interventions-page/transport-interventions-page-request';

@Component({
  selector: 'app-transport-interventions-settings',
  templateUrl: './transport-interventions-settings.component.html',
  styleUrls: ['./transport-interventions-settings.component.scss']
})
export class TransportInterventionsSettingsComponent implements OnInit {

  @Input()
  request: TransportInterventionsPageRequest;

  @Input()
  width: number;

  @Input()
  height: number;

  @Input()
  visible: boolean;

  constructor() {
  }

  ngOnInit(): void {
  }

}
